// Libs
import React from 'react'

// CSS
import './styles.scss'

const CloseIcon = ({ width, color, ...props }) => {
  const closeIconIconStyle = {
    width: `${width}px`,
    height: `${width}px`
  }

  return (
    <span
      style={closeIconIconStyle}
      className={color ? `close-icon__icon close-icon__icon--${color}` : 'close-icon__icon'}
      {...props}
    />
  )
}

export default CloseIcon
